import * as React from "react";

const ArrowForwardContact = (props) => (
  <svg
    width={20}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.293.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L16.586 9H1a1 1 0 0 1 0-2h15.586l-5.293-5.293a1 1 0 0 1 0-1.414Z"
      fill="#fff"
    />
  </svg>
);

export default ArrowForwardContact;
